<div class="app-twitter-callback">
    <div class="container-fluid loader" *ngIf="loading">
        <div class="loader-content">
            <cf-loader [diameter]="50"></cf-loader>
        </div>
    </div>
</div>